module.exports = __webpack_public_path__ + "static/img/text-image-2.87cb9668.png";